import { type FC } from 'react'

import { ProductDescriptionParsedField } from './ProductDescriptionParsedField'

export const ProductDescriptionLegalName: FC<{
  legalName: string
}> = ({ legalName }) => {
  return (
    <ProductDescriptionParsedField className="not-prose" field={legalName} />
  )
}
